export default "__VITE_ASSET__CaK8fBsC__"